import { render } from "./MassageShape.vue?vue&type=template&id=2ebde346"
import script from "./MassageShape.vue?vue&type=script&lang=js"
export * from "./MassageShape.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__